import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from '@material-ui/core';
const useStyles = makeStyles(() => ({
    container: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
    },
}));
/**
 * Container component for displaying the logo, right content and optional
 *
 * @param {React.ReactElement} props.componentCenter - The component to be rendered in the center of the `AppBar`.
 * @param {React.ReactElement} props.componentRight - The component to be rendered on the right side of the `AppBar`.
 * @param {string} props.logo - The path to the logo for the `AppBar`.
 * @returns {JSX.Element} The rendered `AppBar` component.
 */
export function AppBar({ componentCenter, componentRight, logo }) {
    const classes = useStyles();
    return (_jsxs("div", { className: classes.container, children: [logo, componentCenter && _jsx("div", { children: componentCenter }), componentRight] }));
}
